import { Controller } from 'stimulus'

export default class extends Controller {
  static values = {
    newWindow: Boolean,
    url: String
  }

  click() {
    if (event.target.tagName == 'A') { return }
    if (event.target.tagName == 'INPUT') { return }
    if (event.target.tagName == 'TR') { return }
    if (event.target.closest('.not-clickable')) { return }

    if (this.newWindowValue) {
      window.open(this.urlValue)
    } else {
      window.location = this.urlValue
    }
  }
}
